import type { Store } from '@/Domain/entities/Store';
import type { StoreRepository } from '@/Domain/repositories/StoreRepository';
import type { Commune } from '@/modules/region/domain/Region';

import { stores } from './stores.mock';

const getByComuna = async (commune: Commune['code']): Promise<Store[]> =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve(stores.filter((store) => store.address.commune === commune));
    }, 1000);
  });

export const storeRepository: StoreRepository = {
  getByComuna
};
